var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"z-20 hidden w-64 overflow-y-auto bg-primary md:block flex-shrink-0",attrs:{"id":"desktop-sidebar"}},[_c('SidebarContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }